import Vue from 'vue'
import jQuery from 'jquery';
global.jQuery = jQuery;
global.$ = jQuery;

import router from './router'
import _axios from './plugins/axios'
import store from './store'
import App from './App.vue'
import "./filters";
import VueToastr from "vue-toastr";
import VueSweetalert2 from 'vue-sweetalert2';
import VeeValidate from "vee-validate";
import VueNumeric from 'vue-numeric'
import VueProgressBar from 'vue-progressbar';

const options = {
    color: '#f7f201',
    failedColor: '#ea4335',
    thickness: '5px',
    transition: {
        speed: '0.02s',
        opacity: '0.6',
        termination: 100
    },
    autoRevert: false,
    location: 'top',
    inverse: false
};

Vue.use(VueProgressBar, options);
Vue.use(VueNumeric);
Vue.use(VueSweetalert2, {
    confirmButtonColor: '#41b882',
    cancelButtonColor: '#ff7674'
});
Vue.use(VueToastr);
Vue.use(VeeValidate);

Vue.config.productionTip = false;

import Loading from "./components/Loading"

Vue.component('loading', Loading);

import Pagination from "./components/Pagination";

Vue.component('pagination', Pagination);

// import ApiTable from "./components/ApiTable"
// Vue.component('api-table', ApiTable);

import PhoneNumber from "./components/PhoneNumber"

Vue.component('phone-number', PhoneNumber);

import Modal from "./components/Modal"

Vue.component('modal', Modal);

// My modules
import { Auth } from './plugins/auth'

Vue.use(Auth);

import { Numeral } from './plugins/numeral'

Vue.use(Numeral);

import vSelect from 'vue-select'

Vue.component('v-select', vSelect);

import { Errors } from './plugins/errors'

Vue.use(Errors);

import { Permissions } from './plugins/permissions'

Vue.use(Permissions);

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || process.env.VUE_APP_NAME;
    next();
});

const app = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

_axios.interceptors.request.use(function(config) {
    app.$Progress.start();
    return config;
});

_axios.interceptors.response.use(function(response) {
        app.$Progress.finish();
        return response;
    },
    function(error) {
        app.$Progress.fail();
        return Promise.reject(error);
    }
);
